import NodeIds from './NodeIds';

const InputIds = {
    [NodeIds.GeneralInformation]: {
        Title: 'Title',
        MainClass: 'MainClass',
        Class: 'Class',
        SubClass: 'SubClass',
        TypeOfParticipation: 'TypeOfParticipation',
        Lifecycle: 'Lifecycle',
        UnderwritingYear: 'UnderwritingYear',
        PeriodStart: 'PeriodStart',
        PeriodEnd: 'PeriodEnd',
        Currency: 'Currency',
        Countries: 'Countries',
        CountryGroups: 'CountryGroups',
        Cedent: 'Cedent',
        Reinsurer: 'Reinsurer',
        CreateProgram: 'CreateProgram',
        ReportUnits: 'ReportUnits',
        BusinessType: 'BusinessType',
        Insured: 'Insured',
        Broker: 'Broker',
        BusinessId: 'BusinessId',
        ExpiringPeriodStart: 'ExpiringPeriodStart'
    } as const,
    [NodeIds.Classifications]: {
        MainClass: 'MainClass',
        Class: 'Class',
        SubClass: 'SubClass'
    } as const,
    [NodeIds.Countries]: {
        Countries: 'Countries',
        CountryGroups: 'CountryGroups'
    } as const,
    [NodeIds.Limits]: {
        Cover: 'Cover',
        Excess: 'Excess',
        Liability: 'Liability',
        MainLimit: 'MainLimit',
        TotalSumInsured: 'TotalSumInsured',
        LimitType: 'LimitType',
        LimitValue: 'LimitValue'
    } as const,
    [NodeIds.Premiums]: {
        EstimatedPremiumIncome: 'EstimatedPremiumIncome',
        MinimalPremium: 'MinimalPremium',
        DepositPremium: 'DepositPremium',
        SubjectPremiumIncome: 'SubjectPremiumIncome',
        PremiumRate: 'PremiumRate',
        PremiumType: 'PremiumType',
        TotalGrossPremium: 'TotalGrossPremium',
        AnnualPremium: 'AnnualPremium',
        FlatPremium: 'FlatPremium'
    } as const,
    [NodeIds.Deductions]: {
        Commission: 'Commission',
        Brokerage: 'Brokerage',
        TaxOnPremium: 'TaxOnPremium',
        DeductionType: 'DeductionType',
        DeductionValue: 'DeductionValue'
    } as const,
    [NodeIds.Share]: {
        ShareOffer: 'ShareOffer',
        ShareWritten: 'ShareWritten',
        ShareSigned: 'ShareSigned',
        CessionPercent: 'CessionPercent'
    } as const,
    [NodeIds.Claims]: {
        ClaimBasis: 'ClaimBasis',
        ClaimAdviceLimit: 'ClaimAdviceLimit'
    } as const,
    [NodeIds.PortfolioConditions]: {
        PremiumEntryCalculationMethod: 'PremiumEntryCalculationMethod',
        PremiumEntryPercent: 'PremiumEntryPercent',
        PremiumEntryPercentOf: 'PremiumEntryPercentOf',
        PremiumWithdrawalCalculationMethod: 'PremiumWithdrawalCalculationMethod',
        PremiumWithdrawalPercent: 'PremiumWithdrawalPercent',
        PremiumWithdrawalPercentOf: 'PremiumWithdrawalPercentOf',
        LossEntryCalculationMethod: 'LossEntryCalculationMethod',
        LossEntryPercent: 'LossEntryPercent',
        LossWithdrawalCalculationMethod: 'LossWithdrawalCalculationMethod',
        LossWithdrawalPercent: 'LossWithdrawalPercent'
    } as const,
    [NodeIds.AdminConditions]: {
        CessionBasis: 'CessionBasis',
        CashClaimLimit: 'CashClaimLimit'
    } as const,
    [NodeIds.OtherConditions]: {
        CancellationTerms: 'CancellationTerms',
        NOCPeriod: 'NOCPeriod',
        PremiumPaymentWarranty: 'PremiumPaymentWarranty',
        PPWPeriod: 'PPWPeriod',
        InclusionClauses: 'InclusionClauses',
        ExclusionClauses: 'ExclusionClauses'
    } as const,
    [NodeIds.Instalments]: {
        InstalmentsCount: 'InstalmentsCount',
        InstalmentType: 'InstalmentType',
        FirstInstalmentCount: 'FirstInstalmentCount',
        FirstInstalmentPeriod: 'FirstInstalmentPeriod',
        SubsequentInstalmentCount: 'SubsequentInstalmentCount',
        SubsequentInstalmentPeriod: 'SubsequentInstalmentPeriod'
    } as const,
    [NodeIds.Adjustments]: {
        AdjustmentsCount: 'AdjustmentsCount',
        FirstPeriodCount: 'FirstPeriodCount',
        FirstPeriodTime: 'FirstPeriodTime',
        SubsequentAdjustmentsPeriodCount: 'SubsequentAdjustmentsPeriodCount',
        SubsequentAdjustmentsPeriodTime: 'SubsequentAdjustmentsPeriodTime',
        SubmissionWithinCount: 'SubmissionWithinCount',
        SubmissionWithinPeriod: 'SubmissionWithinPeriod',
        PaymentWithinCount: 'PaymentWithinCount',
        PaymentWithinPeriod: 'PaymentWithinPeriod'
    } as const,
    [NodeIds.Reinstatements]: {
        CurrencyType: 'CurrencyType',
        CalculationRule: 'CalculationRule',
        ReinstatementsType: 'ReinstatementsType',
        CountOfReinstatements: 'CountOfReinstatements',
        PaymentRule: 'PaymentRule',
        AmountPercent: 'AmountPercent',
        TimePercent: 'TimePercent',
        BrokerageType: 'BrokerageType',
        BrokeragePercent: 'BrokeragePercent'
    } as const
} as const;

export default InputIds;
